import React, { useEffect, useState } from "react";
import Lenis from "@studio-freight/lenis";

const SmoothScroll = ({ children }) => {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    // Check on mount
    const checkMobile = () => {
        setIsMobile(window.innerWidth < 1024 || 'ontouchstart' in window);
    };
    checkMobile();

    // If mobile, don't init Lenis
    if (window.innerWidth < 1024 || 'ontouchstart' in window) return;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return <div className="smooth-scroll-wrapper">{children}</div>;
};

export default SmoothScroll;
